module.exports = __webpack_public_path__ + "static/media/peijiansuopei641.70952986.png";